module.exports = __webpack_public_path__ + "img/4-1-north-3.ce30e7ac.jpg";